import { Navigate, Route, useParams } from 'react-router-dom'

import Index from 'Components/Pages/Index'
import Login from 'Components/Pages/Login'
import ResetPassword from 'Components/Pages/ResetPassword'
import ResetPasswordSuccess from 'Components/Pages/ResetPasswordSuccess'
import NewPassword from 'Components/Pages/NewPassword'
import NewPasswordSuccess from 'Components/Pages/NewPasswordSuccess'
import SignUp from 'Components/Pages/SignUp'
import SignUpResponse from 'Components/Pages/SignUpResponse'
import BypassRedirectPath from 'Data/BypassRedirectPath.json'

const CustomerLanguageGuard = ({ render }) => {
    const { customerId, language } = useParams()
    if (BypassRedirectPath.includes(customerId)) {
        return <Navigate to={`/${customerId}`} replace />
    }
    return render
}

const AuthRoutes = ({ withLoginWrapper, bypassPath }) => [
    <Route key="customer-language" path="/:customerId/:language" element={<CustomerLanguageGuard render={withLoginWrapper(<Index />)} />} />,
    <Route key="customer" path="/:customerId" element={withLoginWrapper(<Index />)} />,
    <Route
        key="root"
        path="/"
        element={bypassPath.isBypass ? <Navigate to={bypassPath.path} replace /> : withLoginWrapper(<Index />)}
    />,
    <Route key="reset-password" path="/reset-password" element={<ResetPassword />} />,
    <Route
        key="reset-password-success"
        path="/reset-password-success"
        element={<ResetPasswordSuccess type={'success'} />}
    />,
    <Route key="reset-password-error" path="/reset-password-error" element={<ResetPasswordSuccess type={'error'} />} />,
    <Route key="new-password" path="/new-password/:token" element={<NewPassword />} />,
    <Route key="new-password-success" path="/new-password-success" element={<NewPasswordSuccess type={'success'} />} />,
    <Route key="new-password-error" path="/new-password-error" element={<NewPasswordSuccess type={'error'} />} />,
    <Route key="login" path="/login" element={withLoginWrapper(<Login />)} />,
    <Route key="sign-up" path="/sign-up" element={<SignUp />} />,
    <Route key="sign-up-success" path="/sign-up-success" element={<SignUpResponse type={'success'} />} />,
    <Route key="sign-up-error" path="/sign-up-error" element={<SignUpResponse type={'error'} />} />
]

export default AuthRoutes

